import { render, staticRenderFns } from "./AvatarUpload.vue?vue&type=template&id=1eb7460e&"
import script from "./AvatarUpload.vue?vue&type=script&lang=ts&"
export * from "./AvatarUpload.vue?vue&type=script&lang=ts&"
import style0 from "./AvatarUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
